export const API_HOST = "api";
export const API_DOMAIN = "dev.saasbase.io";
export const API_PATH = "mgmt/v1";

export const DEFAULT_LOCALE = "us";
export const DEFAULT_PROJECT_ID = "proj_06fghx60hnrcxftadsj44e0pj8";
